import { ComponentPropsWithoutRef, useContext } from 'react';
import { maskWholeNumber, pluralize } from '@givebutter/util';
import { TableCoreStateContext } from 'components/table/TableCoreStateContext';
import { twMerge } from 'tailwind-merge';

interface TableResultsCountProps extends ComponentPropsWithoutRef<'div'> {
    fallbackTotal?: number;
}

const TableResultsCount = (props: TableResultsCountProps) => {
    const { fallbackTotal, className = '', ...rest } = props;
    const { query } = useContext(TableCoreStateContext);
    const total = query?.data?.meta.total ?? fallbackTotal;

    if (!total) {
        return null;
    }

    return (
        <p className={twMerge('text-sm text-gray-500', className)} {...rest}>
            Showing {maskWholeNumber(total)} {pluralize(total, 'result')}
        </p>
    );
};

export { TableResultsCount };
